import { useParams } from "react-router-dom";
import { IFormSection, TSubmitType } from "../../types/common";
import { URL_ASSIGNED_TICKETS } from "../../utils/urls";
import { getRegister } from "../../utils/helpers";
import { INCIDENT_TICKETING_API } from "../../utils/apis";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useTicketResolutionForm = () => {
  const { parent_id } = useParams<{ parent_id: string }>();

  const sections: IFormSection[] = [
    {
      title: "Ticket Resolution",
      fields: [
        {
          field_name: "diagnosis",
          type: "textarea",
          label: "Diagnosis",
        },

        {
          field_name: "backlog_resolution",
          type: "textarea",
          label: "Backlog Resolution",
        },
        {
          field_name: "permanent_fix",
          type: "select",
          label: "Permanent Fix?",

          props: { required: true },
          options_data: [
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ],
        },

        {
          field_name: "action_taken",
          type: "textarea",
          label: "Action Taken",
        },
      ],
    },
  ];

  const redirect = getRegister(URL_ASSIGNED_TICKETS);

  const onSubmit = (payload: any) => {
    return {
      api: `${INCIDENT_TICKETING_API}${parent_id}/resolve/`,
      params: payload,
      method: "POST",
    };
  };

  return { sections, redirect, onSubmit };
};

export function submitTicketResolution(payload: any, id: number | null) {
  return {
    api: `${INCIDENT_TICKETING_API}${id}/resolve/`,
    params: payload,
    method: "POST",
  };
}
